var render, staticRenderFns
import script from "./shopping-cart.vue?vue&type=script&lang=jsx"
export * from "./shopping-cart.vue?vue&type=script&lang=jsx"
import style0 from "./shopping-cart.vue?vue&type=style&index=0&id=46f13ba9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports